export default "__VITE_ASSET__ea7ebc8f__"